module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/ozonBannerImage-af230701095d86959542f90e9be19adc.png";